import { Flex, SecondaryButton } from '@equifinance/shared';
import styled from 'styled-components';

export const AccountButtonContainer = styled(Flex)`${({ theme }) => `
  justify-content:end;
  gap: ${theme.padding[6]};
`}`;

export const AccountButton = styled(SecondaryButton).attrs(() => ({
  small: true,
}))`
  width: fit-content;
`;
